import { hashSha } from '@farmersdog/utils';

export async function hashPii(pii: string) {
  return await hashSha({ stringToHash: pii });
}
